// ExpiringAccountsBubbleChart.jsx
import React from "react";

const COLORS = [
  "#ad3bdd", // 0-7 days
  "#B282F9",   // 8-15 days
  "#9500D3",   // 16-30 days
];

const ExpiringAccountsBubbleChart = ({
  segments = [
    { name: "0-7 Days", value: 0 },
    { name: "8-15 Days", value: 0 },
    { name: "16-30 Days", value: 0 },
  ],
  onSegmentClick,
}) => {
  const values = segments.map((s) => s.value);
  const maxValue = Math.max(...values, 1); // avoid divide-by-zero
  const baseSize = 60;
  const maxSize = 180;
  const scaleFactor = (maxSize - baseSize) / maxValue;
  const sizes = values.map((v) => baseSize + v * scaleFactor);

  const bubbles = values.map((value, i) => ({
    value,
    size: sizes[i],
    color: COLORS[i],
    label: segments[i].name,
    key: segments[i].name,
  }));

  // Move largest bubble to the back (index 0) so smaller ones appear on top
  const largestIndex = values.indexOf(maxValue);
  const largest = bubbles.splice(largestIndex, 1)[0];
  bubbles.unshift(largest);

  return (
    <div className="relative" style={{ width: 320, height: 300 }}>
      {/* Largest bubble (center, behind others) */}
      <div
        className="absolute rounded-full shadow-lg transition-all duration-300 hover:scale-105 cursor-pointer border-2 border-white/20 flex items-center justify-center text-white font-bold"
        style={{
          width: `${bubbles[0].size}px`,
          height: `${bubbles[0].size}px`,
          background: `radial-gradient(circle at 30% 30%, ${bubbles[0].color}, ${bubbles[0].color}dd)`,
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: bubbles[0].size > 120 ? "3.5rem" : "2.5rem",
          zIndex: 1,
        }}
        onClick={() => onSegmentClick(bubbles[0].key)}
        title={bubbles[0].label}
      >
        {bubbles[0].value}
      </div>

      {/* Top-right bubble */}
      <div
        className="absolute rounded-full shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer border-2 border-white/20 flex items-center justify-center text-white font-bold"
        style={{
          width: `${bubbles[1].size}px`,
          height: `${bubbles[1].size}px`,
          background: `radial-gradient(circle at 30% 30%, ${bubbles[1].color}, ${bubbles[1].color}dd)`,
          left: "75%",
          top: "25%",
          transform: "translate(-50%, -50%)",
          fontSize: bubbles[1].size > 100 ? "2rem" : "1.5rem",
          zIndex: 2,
        }}
        onClick={() => onSegmentClick(bubbles[1].key)}
        title={bubbles[1].label}
      >
        {bubbles[1].value}
      </div>

      {/* Bottom-left bubble */}
      <div
        className="absolute rounded-full shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer border-2 border-white/20 flex items-center justify-center text-white font-bold"
        style={{
          width: `${bubbles[2].size}px`,
          height: `${bubbles[2].size}px`,
          background: `radial-gradient(circle at 30% 30%, ${bubbles[2].color}, ${bubbles[2].color}dd)`,
          left: "25%",
          top: "75%",
          transform: "translate(-50%, -50%)",
          fontSize: bubbles[2].size > 100 ? "2rem" : "1.5rem",
          zIndex: 2,
        }}
        onClick={() => onSegmentClick(bubbles[2].key)}
        title={bubbles[2].label}
      >
        {bubbles[2].value}
      </div>
    </div>
  );
};

export default ExpiringAccountsBubbleChart;